/**
 * @generated SignedSource<<a8246f6033abdea48c96ca18a1d857f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionScreenListItemComponent_TaskExecution$data = {
  readonly id: string;
  readonly sectionId: string;
  readonly task: {
    readonly id: string;
    readonly instructions: string | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionListItemComponent_taskExecution">;
  readonly " $fragmentType": "RoutineOccasionScreenListItemComponent_TaskExecution";
};
export type RoutineOccasionScreenListItemComponent_TaskExecution$key = {
  readonly " $data"?: RoutineOccasionScreenListItemComponent_TaskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionScreenListItemComponent_TaskExecution">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionScreenListItemComponent_TaskExecution",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sectionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instructions",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskExecutionListItemComponent_taskExecution"
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};
})();

(node as any).hash = "8cc4b6fa009958c06a32aff68625dddf";

export default node;
